import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { postApi, putApi } from "../../../Services/apiService";
import { toast } from "react-toastify";

function Profile() {
  const [methodType, setMethodType] = useState('');
  const { data } = useSelector((state) => state.roleData);

  const userData = JSON.parse(localStorage.getItem('userDetail'))

  const [name, setName] = useState(userData?.name || '')
  const [email, setEmail] = useState(userData?.email || '')
  const [profile, setProfile] = useState();
  const [profilePreview, setProfilePreview] = useState();
  const [isLoading,setIsLoading] = useState(false)

  const handleUpdateProfile = async () => {
    setIsLoading(true)
    const formData = new FormData()

    formData.append('name', name)
    // formData.append('email',email)
    if(profilePreview){
    formData.append('image', profilePreview)
    }
    const resp = await postApi('/user/profile', formData)
    if (resp?.success) {
      toast.success('Profile updated successfully')
      localStorage.setItem("userDetail", JSON.stringify(resp?.data?.user));
    }
    setIsLoading(false)
  }

  const handleFileChange = (e, type) => {
    // setUpdateProfileData(true)
    const file = e.target.files[0];
    if (file) {
      // const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      //   if (file.size > maxSize) {
      // toast.error("File size exceeds 5MB. Please upload a smaller image.");
      // return;
      // }
      setProfilePreview(file)

      // setNewCategory(prevState => ({ ...prevState, image: file }));
      const reader = new FileReader();

      reader.onloadend = () => {
        setProfile(reader.result);

      };
      reader.readAsDataURL(file);
    }
  };


  return (
    <div className="RightSideDiv">
      <div className="row">
        <div className="col-sm-12">
          <div className="setting-right position-relative">
            <h3>User Profile</h3>
            {/* <img src={window.getPublicUrl('/assets/images/close.svg')} className='close' alt="" /> */}
            <div className="setting-inner">
              <div className="row">
              <div className="col-sm-4">
                <div className="row">
                <div className="col-sm-12 text-center mb-3 profile-pic">
                  <span className="position-relative">
                
                <img src={profile||userData?.profile_image_path ||  window.getPublicUrl("/assets/images/user-pic.png")}  alt="" />
                <p className="profile-edit-icon">
                <img src={window.getPublicUrl('/assets/images/edit-profile.svg') } alt=""  className="profile-edit-img"/>
                </p>
                {/* <img src={window.getPublicUrl('/assets/images/user-profile.svg')}  alt="" /> */}
                <input type="file" onChange={(e)=>handleFileChange(e)} accept="image/*" className="edit-profile" />
                </span>
               
              
                  </div>
                <div className="col-sm-12">
                    <div className="form-group">
                      <label>
                        Name<strong>*</strong>
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter Name"
                        value={name}
                        onChange={(e)=>setName(e?.target?.value)}
                      ></input>
                    </div>
                    {/* <div className="col-sm-12">
                      <div className="form-group">
                        <label>
                          Name<strong>*</strong>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Name"
                          value={name}
                          onChange={(e) => setName(e?.target?.value)}
                        ></input>
                      </div>
                    </div> */}
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>
                          Email<strong>*</strong>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Email"
                          value={email}
                          onChange={(e) => setEmail(e?.target?.value)}
                          disabled
                        ></input>
                      </div>
                    </div>
                    {/* <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Phone <strong>*</strong>
                      </label>
                      <input
                        type="Number"
                        class="form-control"
                        placeholder="Enter Number"
                      ></input>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Address<strong>*</strong>
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter Address"
                      ></input>
                    </div>
                  </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="button-settings">
              <div className="col-sm-12">
                <div className="d-flex justify-content-end gap-3">
                  <button className="reset" onClick={()=>{setName(userData?.name);setEmail(userData?.email);setProfilePreview();setProfile()}}>Reset</button>
                  <button className="save" onClick={() => handleUpdateProfile()} disabled={isLoading}>
                 {isLoading && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}Save
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

    </div>
  );
}

export default Profile;
